import { getDefaultBrushAttribute, getDefaultBrushPoint } from '@meitu/saas-editor-core/es/layers/brush-layer';
import {
    BrushDasharrayType,
    BrushLinecapType,
    BrushPointType,
    BrushType,
} from '@meitu/saas-editor-core/es/version-types';
import { getBrushPointListMaterialConfig, getMarkupPointListMaterialConfig } from '@/editor/point-config';
import { MaterialListItem } from '@/services/material/index.d';
import { isDevelopEnv, isPreEnv } from '@/utils/env';
import preset1 from './assets/1.png';
import preset2 from './assets/2.png';
import preset3 from './assets/3.png';
import preset4 from './assets/4.png';
import preset5 from './assets/5.png';
import preset6 from './assets/6.png';
import preset7 from './assets/7.png';
import preset8 from './assets/8.png';

/**
 * 内置的列表配置
 */
const presetList: any[] = [
    {
        name: 'preset-1',
        id: Math.random(),
        threshold: 0,
        is_preset: 1,
        thumbnail: {
            width: 500,
            height: 500,
            url: preset1,
        },
        svg: {
            brush: true,
            info: JSON.stringify({
                brushType: BrushType.Line,
                fills: [
                    {
                        ...getDefaultBrushAttribute(),
                        color: '#797c81ff',
                        width: 9,
                        linecap: BrushLinecapType.Round,
                        dasharray: BrushDasharrayType.Solid,
                    },
                ],
            }),
        },
    },
    {
        name: 'preset-2',
        id: Math.random(),
        threshold: 0,
        is_preset: 1,
        thumbnail: {
            width: 500,
            height: 500,
            url: preset2,
        },
        svg: {
            brush: true,
            info: JSON.stringify({
                brushType: BrushType.Line,
                fills: [
                    {
                        ...getDefaultBrushAttribute(),
                        color: '#797c81ff',
                        width: 14,
                        linecap: BrushLinecapType.Round,
                        dasharray: BrushDasharrayType.Dot,
                    },
                ],
            }),
        },
    },
    {
        name: 'preset-3',
        id: Math.random(),
        threshold: 0,
        is_preset: 1,
        thumbnail: {
            width: 500,
            height: 500,
            url: preset3,
        },
        svg: {
            brush: true,
            info: JSON.stringify({
                brushType: BrushType.Line,
                fills: [
                    {
                        ...getDefaultBrushAttribute(),
                        color: '#797c81ff',
                        width: 9,
                        linecap: BrushLinecapType.Square,
                        dasharray: BrushDasharrayType.Square,
                    },
                ],
            }),
        },
    },
    {
        name: 'preset-4',
        id: Math.random(),
        threshold: 0,
        is_preset: 1,
        thumbnail: {
            width: 500,
            height: 500,
            url: preset4,
        },
        svg: {
            brush: true,
            info: JSON.stringify({
                brushType: BrushType.Arrow,
                fills: [
                    {
                        ...getDefaultBrushAttribute(),
                        color: '#797c81ff',
                        width: 8,
                        linecap: BrushLinecapType.Square,
                    },
                ],
                startPoint: {
                    type: BrushPointType.SolidCircle,
                    ...getMarkupPointListMaterialConfig()[BrushPointType.SolidCircle],
                },
                endPoint: getDefaultBrushPoint(),
            }),
        },
    },

    {
        name: 'preset-5',
        id: Math.random(),
        threshold: 0,
        is_preset: 1,
        thumbnail: {
            width: 500,
            height: 500,
            url: preset5,
        },
        svg: {
            brush: true,
            info: JSON.stringify({
                brushType: BrushType.Arrow,
                fills: [
                    {
                        ...getDefaultBrushAttribute(),
                        color: '#797c81ff',
                        width: 12,
                        linecap: BrushLinecapType.Square,
                    },
                ],
                startPoint: getDefaultBrushPoint(),
                endPoint: {
                    type: BrushPointType.SolidTriangle,
                    ...getBrushPointListMaterialConfig()[BrushPointType.SolidTriangle],
                },
            }),
        },
    },

    {
        name: 'preset-6',
        id: Math.random(),
        threshold: 0,
        is_preset: 1,
        thumbnail: {
            width: 500,
            height: 500,
            url: preset6,
        },
        svg: {
            brush: true,
            info: JSON.stringify({
                brushType: BrushType.Arrow,
                fills: [
                    {
                        ...getDefaultBrushAttribute(),
                        color: '#797c81ff',
                        width: 12,
                        linecap: BrushLinecapType.Square,
                    },
                ],
                startPoint: getDefaultBrushPoint(),
                endPoint: {
                    type: BrushPointType.CurvedArrow,
                    ...getBrushPointListMaterialConfig()[BrushPointType.CurvedArrow],
                },
            }),
        },
    },

    {
        name: 'preset-7',
        id: Math.random(),
        threshold: 0,
        is_preset: 1,
        thumbnail: {
            width: 500,
            height: 500,
            url: preset7,
        },
        svg: {
            brush: true,
            info: JSON.stringify({
                brushType: BrushType.Arrow,
                fills: [
                    {
                        ...getDefaultBrushAttribute(),
                        color: '#797c81ff',
                        width: 10,
                        linecap: BrushLinecapType.Round,
                        dasharray: BrushDasharrayType.Dashed,
                    },
                ],
                startPoint: {
                    type: BrushPointType.StraightArrow,
                    ...getBrushPointListMaterialConfig()[BrushPointType.StraightArrow],
                },
                endPoint: {
                    type: BrushPointType.StraightArrow,
                    ...getBrushPointListMaterialConfig()[BrushPointType.StraightArrow],
                },
            }),
        },
    },

    {
        name: 'preset-8',
        id: Math.random(),
        threshold: 0,
        is_preset: 1,
        thumbnail: {
            width: 500,
            height: 500,
            url: preset8,
        },
        svg: {
            brush: true,
            info: JSON.stringify({
                brushType: BrushType.Arrow,
                fills: [
                    {
                        ...getDefaultBrushAttribute(),
                        color: '#797c81ff',
                        width: 10,
                        linecap: BrushLinecapType.Square,
                    },
                ],
                startPoint: {
                    type: BrushPointType.VerticalShape,
                    ...getBrushPointListMaterialConfig()[BrushPointType.VerticalShape],
                },
                endPoint: {
                    type: BrushPointType.VerticalShape,
                    ...getBrushPointListMaterialConfig()[BrushPointType.VerticalShape],
                },
            }),
        },
    },
];

/**
 * 合并内置+服务端列表
 *
 * @param data - 素材列表项
 * @param id - ID
 */
export function mergePresetList(data: MaterialListItem[], id?: string | number) {
    if ((isPreEnv() || isDevelopEnv()) && id === 'newMaterial') {
        return presetList.concat(data);
    } else {
        // 线条分类
        if (id === 2895) {
            return presetList.concat(data);
        }
    }
    return data;
}
